import { render, staticRenderFns } from "./TradeResult.vue?vue&type=template&id=2ca1ebe5&scoped=true&"
import script from "./TradeResult.vue?vue&type=script&lang=js&"
export * from "./TradeResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca1ebe5",
  null
  
)

export default component.exports